import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { MsalService } from "@azure/msal-angular";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
  })
  class RoleGuardService {
  
    constructor(private router: Router, private authService: MsalService) {}
  
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        const allowedRoles = next.data.allowedRoles;
        if (allowedRoles) {
            const account = this.authService.instance.getActiveAccount();
            if (allowedRoles.some((role: string) => account?.idTokenClaims?.roles?.includes(role))) {
                return true;
            }
            return this.router.parseUrl('access-forbidden');
        }

        return true;
    }
  }

export const RoleGuard: CanActivateFn  = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
    return inject(RoleGuardService).canActivate(next, state);
}